var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex space-x-3 cursor-pointer items-center",class:[("icon-" + _vm.color)]},[_c('span',{class:[
      ("material-icons-" + _vm.mode),
      ("icon-" + _vm.size),
      ("gradient-" + _vm.gradient) ]},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]),_vm._v(" "),_c('span',{class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }